import {combineReducers} from 'redux'

import activity from './activity'
import card from './card'
import chat from './chat'
import collection from './collection'
import deviceInfo from './deviceInfo'
import env from './env'
import event from './event'
import faq from './faq'
import home from './home'
import invite from './invite'
import moment from './moment'
import questionnaire from './questionnaire'
import rank from './rank'
import recharge from './recharge'
import role from './role'

export default combineReducers({
  deviceInfo,
  env,
  home,
  role,
  chat,
  event,
  card,
  collection,
  moment,
  recharge,
  invite,
  faq,
  rank,
  activity,
  questionnaire,
})
